"use client"

import { useState } from "react"
import styles from "./Tabs.module.css"

const Tabs = ({ tabs = [], activeTab, onChange, variant = "default", size = "medium", className = "" }) => {
  const [internalActiveTab, setInternalActiveTab] = useState(activeTab || tabs[0]?.id)

  const currentActiveTab = activeTab !== undefined ? activeTab : internalActiveTab

  const handleTabClick = (tabId) => {
    if (onChange) {
      onChange(tabId)
    } else {
      setInternalActiveTab(tabId)
    }
  }

  const activeTabContent = tabs.find((tab) => tab.id === currentActiveTab)

  const tabsClasses = [styles.tabs, styles[variant], styles[size], className].filter(Boolean).join(" ")

  return (
    <div className={styles.container}>
      <div className={tabsClasses} role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tab} ${
              currentActiveTab === tab.id ? styles.active : ""
            } ${tab.disabled ? styles.disabled : ""}`}
            onClick={() => !tab.disabled && handleTabClick(tab.id)}
            disabled={tab.disabled}
            role="tab"
            aria-selected={currentActiveTab === tab.id}
            aria-controls={`panel-${tab.id}`}
          >
            {tab.icon && <span className={styles.icon}>{tab.icon}</span>}
            {tab.label}
            {tab.badge && <span className={styles.badge}>{tab.badge}</span>}
          </button>
        ))}
      </div>

      <div className={styles.content}>
        {activeTabContent && (
          <div
            className={styles.panel}
            role="tabpanel"
            id={`panel-${activeTabContent.id}`}
            aria-labelledby={`tab-${activeTabContent.id}`}
          >
            {activeTabContent.content}
          </div>
        )}
      </div>
    </div>
  )
}

export default Tabs
